import { render, staticRenderFns } from "./AuditoriaIndex.vue?vue&type=template&id=74469db2"
import script from "./AuditoriaIndex.vue?vue&type=script&lang=js"
export * from "./AuditoriaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports